import './assets/css/selected-info-panel.css';
import Icon, { InfoOutlined } from '@ant-design/icons';

function SelectedInfoPanel({
  title,
  content,
  placeholder = 'Select an option above',
  showPlaceholder = true,
  className = '',
  icon = <InfoOutlined />,
  iconSize = 1.3,
}) {
  return (
    <div className={'selected-info-panel w-full ' + className}>
      <Icon
        className={'selected-info-panel__icon'}
        style={{ fontSize: `${iconSize}rem` }}
        component={() => icon}
      />
      <div className={'gMedium sb-blue'}>{title}</div>
      <div className={'gSemiBold'}>
        {!showPlaceholder ? (
          content
        ) : (
          <span className={'sb-grey gLight fs-13'}>{placeholder}</span>
        )}
      </div>
    </div>
  );
}

export default SelectedInfoPanel;
